import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { VscSymbolMethod } from "react-icons/vsc";
import { MdEditLocationAlt } from "react-icons/md";
import { FaHandPointDown } from "react-icons/fa";
import { connect } from "react-redux";
import {
  FullAccessRoles,
  ExcepEmployeeAdmin,
} from "../../router/permission";
import { FaUser } from "react-icons/fa6";
const MyAsset = ({ userRole }) => {
  const tabs = [
    {
      name: "My Asset",
      icons: <FaHandPointDown className="me-1" />,
      path: `/my-asset`,
      access: FullAccessRoles,
    },
    {
      name: "Department",
      icons: <VscSymbolMethod className="me-1" />,
      path: `/my-asset/department-asset`,
      access:ExcepEmployeeAdmin,
    },
    {
      name: "Employee With Assets",
      icons: <FaUser size={15} className="me-1" />,
      path: `/my-asset/departmentEmp-asset`,
      access: ExcepEmployeeAdmin,
    },
  ];
  const visibleTabs = tabs.filter((tab) => tab.access.includes(userRole));
  return (
    <>
      <div className="card d-flex flex-row flex-wrap justify-content-between pt-2 px-3 mb-3">
        <div className="mb-2">
          <h2 className="text-primary">My Assets</h2>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to="/assets/table-view">My Assets</Link>
            </li>
          </ol>
        </div>
        <div className="align-self-end">
        {visibleTabs.length > 1 && (
          <ul className="nav custom-sidebar-nav gap-3">
            {visibleTabs.map((tab) => (
              <li className="nav-item" key={tab.path}>
                <NavLink
                  to={tab.path}
                  end={true}
                  className={({ isActive }) =>
                    "nav-link" + (isActive ? " active" : "")
                  }
                >
                  {tab.icons}
                  {tab.name}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
        </div>
      </div>
      <div>
        <Outlet />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "user",
});

export default connect(mapStateToProps)(MyAsset);
